import { render, staticRenderFns } from "./AdminHeaderCom.vue?vue&type=template&id=7de0d72e&"
import script from "./AdminHeaderCom.vue?vue&type=script&lang=ts&"
export * from "./AdminHeaderCom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports